import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const productsJcsCustomerAccessEntryPoint = createEntryPoint({
	root: JSResourceForUserVisible(
		() => import(/* webpackChunkName: "async-products-jcs-customer-access" */ './src/ui'),
	),
	getPreloadProps: () => ({}),
});
